/**
 * Where the interface sends a reader who wants to know more.
 *
 * `client/help.tsx` is the whole of Ondit's in-product help: one page, one
 * section per topic, addressed by anchor. Naming the anchors here is what keeps
 * a link honest — the paths these used to point at (`/help/tables`,
 * `/help/logs-debugging`, `/help/integrations/google-service-account`) matched
 * the route, so every one of them silently served the index with no anchor and
 * looked like it had worked.
 */
export const DOCS_URL = '/help' as const

/** The sections `client/help.tsx` renders, in its own order. */
export const HELP_TOPICS = [
  'chat',
  'workflows',
  'knowledge',
  'schedules',
  'logs',
  'integrations',
] as const

export type HelpTopic = (typeof HELP_TOPICS)[number]

/** The help page at one of its topics. A topic it does not have will not compile. */
export function helpTopicUrl(topic: HelpTopic): string {
  return `${DOCS_URL}#${topic}`
}

/**
 * Ondit has no community workspace to invite anyone into — the Sim invite this
 * replaces named a Slack organization that does not exist — so contacting
 * support is an address, and the same one the help page ends on.
 */
export const SUPPORT_URL = 'mailto:hello@ondit.ai' as const
